import { Mail, Phone, MapPin, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import footerLogo from "@/assets/ndf-logo-v2.png";

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-primary text-primary-foreground py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-12 items-start">
          {/* Links: Who we are */}
          <div>
            <div className="mb-4 -ml-8">
              <img src={footerLogo} alt="New Data Frontier" className="h-28" width={112} height={112} loading="lazy" />
            </div>
            <h3 className="font-semibold text-lg mb-4">{t('footer.whoWeAre')}</h3>
            <p className="text-primary-foreground/80 mb-4">
              {t('footer.description')}
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.linkedin.com/company/datastudent"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-accent transition-colors"
                aria-label="New Data Frontier op LinkedIn">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Midden: Onze merken */}
          <div className="pt-0 lg:pt-28">
            <h3 className="font-semibold text-lg mb-4">Onze merken</h3>
            <ul className="space-y-2 text-primary-foreground/80">
              <li><Link to="/datastudent" className="hover:text-accent transition-colors">DataStudent</Link></li>
              <li><Link to="/new-data-select" className="hover:text-accent transition-colors">New Data Select</Link></li>
              <li><Link to="/dutch-data-company" className="hover:text-accent transition-colors">Dutch Data Company</Link></li>
            </ul>
          </div>

          {/* Rechts: Contact */}
          <div className="pt-0 lg:pt-28 md:ml-auto">
            <h3 className="font-semibold text-lg mb-4">{t('footer.contact')}</h3>
            <ul className="space-y-3 text-primary-foreground/80">
              <li className="flex items-start gap-2">
                <Mail className="h-5 w-5 flex-shrink-0 mt-0.5" />
                <a className="hover:text-accent transition-colors" href="mailto:info@newdatafrontier.com">
                  info@newdatafrontier.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Phone className="h-5 w-5 flex-shrink-0 mt-0.5" />
                <a href="tel:+31639754532" className="hover:text-accent transition-colors">
                  +31 6 39754532 (Wilco)
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="h-5 w-5 flex-shrink-0 mt-0.5" />
                <span>Groot Handelsgebouw Rotterdam, 4e etage</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary-foreground/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-primary-foreground/70">
            <p>&copy; 2025 New Data Frontier. {t('footer.rights')}</p>
            <div className="flex gap-6">
              <Link to="/privacy" className="hover:text-accent transition-colors">{t('footer.privacy')}</Link>
              <Link to="/algemene-voorwaarden" className="hover:text-accent transition-colors">{t('footer.terms')}</Link>
              <a href="https://www.newdatafrontier.com" target="_blank" rel="noopener noreferrer" className="hover:text-accent transition-colors">NewDataFrontier.com</a>
            </div>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;